// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardActivity_cardContainer__K5xDl","parrafosContainer":"CardActivity_parrafosContainer__2_XIZ"};